// extracted by mini-css-extract-plugin
export default {"area-item":"areaItem_area-item__lHpIi","header":"areaItem_header__IRT6g"};